import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import DocumentVault from "@/components/DocumentVault";

/** Admin-only: show any user's signed documents. */
export default function AdminUserDocsDialog({ target, onClose }) {
  return (
    <Dialog open={!!target} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-white border-[#E5E5E3] max-w-2xl max-h-[92vh] overflow-y-auto" data-testid={`admin-user-docs-${target?.user_id || ""}`}>
        <DialogHeader>
          <DialogTitle className="text-2xl font-light" style={{ fontFamily: "Cormorant Garamond, serif" }}>
            Documenti · {target?.name || target?.email}
          </DialogTitle>
        </DialogHeader>
        {target && <DocumentVault userId={target.user_id} />}
      </DialogContent>
    </Dialog>
  );
}
